import { render, staticRenderFns } from "./veStuAssocKj.vue?vue&type=template&id=169ad3b4&scoped=true"
import script from "./veStuAssocKj.vue?vue&type=script&lang=js"
export * from "./veStuAssocKj.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "169ad3b4",
  null
  
)

export default component.exports